import { Box, Fade } from '@mui/material';
import { useViewMode } from 'apps/wrapper/src/hooks/use-view-mode';
import { FC, ReactNode } from 'react';
import { StyledContainer } from './search-bar.styles';

export const SearchDeviceWrapper: FC<{ visible: boolean; children: ReactNode }> = (props) => {
  const { visible, children } = props;
  const { viewMode } = useViewMode();

  return viewMode === 'Phone' || viewMode === 'Tablet' ? (
    <Fade in={visible}>
      <StyledContainer isPhone={viewMode === 'Phone'}>
        <Box display="flex" style={{ height: '40px' }}>
          {children}
        </Box>
      </StyledContainer>
    </Fade>
  ) : (
    <>{children}</>
  );
};
